import { api } from '../../DefaultService';
import { ILprEventProps, ILprEventSimpleProps } from './types';
import { IPaginationParams } from '../../types';

export const LPR_EVENT_ENDPOINT = 'v1/events/lpr';

export const getLprEventByIdAsync = async (
  id: number,
): Promise<ILprEventProps> => {
  return await api
    .get(`${LPR_EVENT_ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllLprEventByLicenseAsync = async (
  params: IPaginationParams,
): Promise<ILprEventSimpleProps[]> => {
  return await api
    .get(`${LPR_EVENT_ENDPOINT}/getAllByLicense`, {
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllLprEventCountByLicenseAsync = async (): Promise<number> => {
  return await api
    .get(`${LPR_EVENT_ENDPOINT}/getAllByLicense/count`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
